import { getComposeStoreManager } from '../store/store';
import type { FullComposeViewState } from 'owa-calendar-compose-types';
import type { ClientAttachmentId, ClientItemId } from 'owa-client-ids';

type IdType = ClientAttachmentId | string | ClientItemId;

export function findFormIdByLinkId(id: IdType): string | null {
    const composeStoreMap = getComposeStoreManager().storeMap;
    const composeFormStores = [...composeStoreMap.values()];
    const filteredEntries = composeFormStores.filter(entry => {
        return (
            (entry.uiState as FullComposeViewState)?.attachmentWell?.sharingLinkIds?.indexOf(
                <string>id
            ) !== -1
        );
    });

    return filteredEntries[0]?.formId;
}
